import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Tooltip, OverlayTrigger, Col, Row } from 'react-bootstrap';
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Download } from 'react-bootstrap-icons';
import ProjectsCustStepper from './ProjectsCustStepper.js';
// import ProjEditForm from './ProjEditForm';
import HashChange from "react-hashchange";
import QuestAddCustApp from './quests/QuestAddCustApp.js';
import QuestSkipCustApp from './quests/QuestSkipCustApp.js';
import QuestTargetCustApp from './quests/QuestTargetCustApp';
import QuestTargetCustNormalApp from './quests/QuestTargetCustNormalApp';
import ProjectsAddCustAppForm from './ProjectsAddCustAppForm';
import ProjAnswerRecord from './ProjAnswerRecord';
import ProjAnswerChart from './ProjAnswerChart';

class ProjectsEditCustApp extends React.Component {
    constE_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    E_STATUS = {
        SUCC: "成功",
        succ: "成功",
        FAIL: "失敗",
        fail: "失敗"
    };

    constructor(props) {
        super(props);

        console.log("[projEditCustApp] const");
        Tools.init();
        API.init(this);

        let step = this.props.match.params.step || 1;
        step = parseInt(step);
        if (isNaN(step)) step = 1;
        // if (step >= 5) step = step + 1;
        this.state = {
            formData: null,
            isLoading: true,
            pid: this.props.match.params.pid,
            step: step,
            isPaid: false,
            isUpsheleProj: false
        };

        if (null != this.props.match.params.oid
            // && null != this.props.match.params.status
            && this.props.history.location.pathname != '/proj/index'
            && this.state.isUpsheleProj == false) {
            this.state.isUpsheleProj = true;
            let tmpStatus = this.props.match.params.status || "succ";
            // let stsStr = this.E_STATUS[tmpStatus] || tmpStatus;
            console.log("history", this.props.history.action, this.props.history.location.pathname);
            // alert(`訂單${this.props.match.params.oid}：付款${stsStr}`);
            this.onProjOnShelve(this.state.pid, [], (isSucc) => {
                this.props.history.push('/proj/index');
            });
            return;
        }

        console.log("ProjectsEditCustApp", this.state);

        if (this.state.pid) {
            this.getData(this.state.pid);
        } else {
            this.state.isLoading = false;
            this.state.formData = {};
        }
        this.getData = this.getData.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.handleOnUrlChange = this.handleOnUrlChange.bind(this);
        this.onCopy = this.onCopy.bind(this);
        this.onDel = this.onDel.bind(this);
        this.onDownloadMember = this.onDownloadMember.bind(this);
        this.onDownloadRecord = this.onDownloadRecord.bind(this);
        this.onDownloadQuestion = this.onDownloadQuestion.bind(this);
        this.onBackToList = this.onBackToList.bind(this);
        this.onStep3 = this.onStep3.bind(this);
        this.onStep4 = this.onStep4.bind(this);
        this.onStep4_2 = this.onStep4_2.bind(this);
        this.onEndStep = this.onEndStep.bind(this);
        this.onClickTest = this.onClickTest.bind(this);
        this.onProjOnShelve = this.onProjOnShelve.bind(this);
    }

    getProjID(hash) {
        const hashList = hash.match(/\/proj\/edit\/(.*)\/(.*)/);
        console.log("!!", hash);
        if (hashList && hashList.length >= 2) return hashList;
        return null;
    }

    onProjOnShelve(pid, targetList, onFinish) {
        var tmpData = {
            id: pid,
            ty: 2 //(items == null || 0 == items.length) ? 0 : 1
        };
        let body = {
            members: targetList.map(x => ({ "ac": x }))
        }

        API.CustomerSendProject(tmpData, body)
            .then((data) => {
                if (data && data.responseData) {
                    try {
                        console.log(data.responseData);
                        alert(data.responseData.msg);
                        //code: "22000"
                        //msg: "操作成功 : 已推送給 1 位會員"
                        if (data.responseData.code == "22000") {
                            // alert("問卷已上架")
                            // props.onFinish();
                            onFinish(true);
                        } else {
                            onFinish(false);
                        }
                    } catch (e) {
                        alert("update error");
                        console.warn(e.stack);
                        onFinish(false);
                    }
                } else {
                    alert("問卷上架失敗");
                    onFinish(false);
                }
            })
    }

    handleOnUrlChange = (data) => {
        let tmp = this.getProjID(data.hash);
        const pid = tmp && tmp.length > 1 ? tmp[1] : null;
        let step = tmp && tmp.length > 2 ? tmp[2] : null;

        console.log("[handleOnUrlChange] pid", pid);
        console.log("[handleOnUrlChange] step", step);
        step = parseInt(step);
        if (pid) {
            this.setState({
                pid: pid,
                step: isNaN(step) ? 0 : step
            });
            this.getData(pid);
        } else {
            this.setState({
                pid: pid,
                formData: {}
            });
        }
    }

    getData(pid, callback) {
        // console.log("!!!!", pid, this);
        if (!pid) return;

        API.GetProjectByID({
            ty: 1, //0=該帳號下全部專案, 1=單⼀一專案
            pi: pid
        })
            .then(response => {
                console.log(response);
                this.setState({
                    isLoading: false,
                });

                if (response && response.responseData) {
                    if (response.responseData.data) {
                        let proj = response.responseData.data[0];
                        //不判斷是否已結帳
                        this.setState({ formData: proj, isPaid: ("" != proj.is_published) });
                        if (callback) callback();
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    onUpdate(data) {
        console.log(data);
        if (null == data) return;
        let p_typeParse = parseInt(data.p_type);
        if (isNaN(p_typeParse)) {
            alert("請選擇問卷類型");
            return;
        }

        // if(data.p_type) data.p_type = parseInt(data.p_type);

        //interval type
        if (data.p_type == 2) {
            if (!data.interval_year) data.interval_year = 0;
            if (!data.interval_month) data.interval_month = 0;
            if (!data.interval_day) data.interval_day = 0;
        }

        this.setState({
            isLoading: true
        });

        API.AddProject({
            ty: 2,
            pi: this.state.pid
        }, data)
            .then(response => {
                console.log(response);

                if (response && response.responseData) {
                    console.log(response.responseData.code);
                    if (response.responseData.code == "22000") {
                        // this.getData(this.state.pid);
                        this.props.history.push('/proj/edit/' + this.state.pid + '/2');
                    } else {
                        alert(response.responseData.msg);
                        this.setState({
                            isLoading: false
                        });
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }


    onCopy() {
        console.log("onCopy");

    }

    onDel() {
        console.log("onDel");
    }

    onDownloadMember() {
        console.log("onDownloadMember");
        API.GetAnswerMemberCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetAnswerMemberCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    onDownloadRecord() {
        console.log("onDownloadRecord");
        API.GetAnswerRecordCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetAnswerRecordCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    onDownloadQuestion(e) {
        e.stopPropagation();
        e.preventDefault();

        console.log("onDownloadQuestion");
        API.GetQuestionOptionsCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetQuestionOptionsCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    onBackToList() {
        this.props.history.push('/proj/index');
    }
    onStep3() {
        this.props.history.push('/proj/edit/' + this.state.pid + '/3');
    }
    onStep4() {
        // alert("step 4 TBD")
        this.props.history.push('/proj/edit/' + this.state.pid + '/4');
        // this.setState({ step: 2 });
    }
    onStep4_2(data) {
        this.getData(this.state.pid, () => {
            this.setState({ step: 4.5 });
        });
        // this.props.history.push('/proj/edit/' + this.state.pid + '/5');
    }
    onStep5(data) {
        this.props.history.push('/proj/edit/' + this.state.pid + '/5');
    }
    onStep6(data) {
        this.props.history.push('/proj/edit/' + this.state.pid + '/6');
    }
    onEndStep() {
        this.props.history.push("/proj/index");
    }

    onClickStep(e) {
        console.log(e, e.target.innerText);
        this.props.history.push('/proj/edit/' + this.state.pid + '/' + e.target.innerText);
    }

    onClickTest(e) {
        console.log("onTest");
        // 0 : 客戶的測試帳號
        // 1 : 指定名單
        // 2 : 依照會員資料條件 (同MemberFilter)
        // 3 : 孵化器編號(僅孵化器客戶可使用)
        var tmpHeader = {
            id: this.state.pid,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        let tmpBody = {
            members: [],
            test_phone: [{ "group_name": "aa" }]
        };
        API.CustomerSendProject(tmpHeader, tmpBody)
            .then(this.checkResult)
    }

    checkResult(data) {
        // console.log(data);
        if (data && data.responseData) {
            try {
                alert(data.responseData.msg);
            } catch (e) {
                alert("update error");
                console.warn(e.stack);
            }
        }
    }

    renderContent() {

        console.log(this);
        if (null == this) return (<div>請稍候...</div>);

        const { isLoading, formData } = this.state;
        const isEditable = (false == this.state.isPaid);

        console.log("[renderContent]", formData);
        if (isLoading) {
            return (
                <div className="h1 mx-auto text-center my-5">Loading..</div>
            );
        } else {
            let stepDom = null;
            switch (this.state.step) {
                case 1:
                case "1":
                    stepDom = (
                        <ProjectsAddCustAppForm
                            formData={formData}
                            onUpdate={this.onUpdate}
                            isDisabled={false}
                            isAddProj={false} />
                    );
                    break;
                case 2:
                case "2":
                    stepDom = (<QuestAddCustApp pi={this.state.pid} isEditable={isEditable} onNextStep={this.onStep3} onBackToList={this.onBackToList} />);
                    break;
                case 3:
                case "3":
                    stepDom = (<QuestSkipCustApp pi={this.state.pid} onNextStep={this.onStep4} onBackToList={this.onBackToList} />);
                    break;
                case 4:
                case "4":
                case 4.5:
                case "4.5":
                    let isAdmin = API.getIsAdmin();
                    if (2 == isAdmin && null != formData) {
                        stepDom = (
                            <QuestTargetCustNormalApp
                                pi={this.state.pid}
                                pdata={formData}
                                onNextStep={this.onStep4_2}
                                onFinish={this.onEndStep}
                                oid={formData.oid}
                                isEditable={isEditable}
                                onBackToList={this.onBackToList}
                                onProjOnShelve={this.onProjOnShelve} />);
                    }
                    else if (3 == isAdmin) {
                        stepDom = (<QuestTargetCustApp pi={this.state.pid} pdata={formData} onNextStep={this.onStep4_2} onFinish={this.onEndStep} />);
                        // stepDom = (<div className="text-center">即將上線</div>)
                    }
                    break;
                case 5:
                case "5":
                    stepDom = (<ProjAnswerRecord pi={this.state.pid} onNextStep={this.onStep4} onBackToList={this.onBackToList} />);
                    break;
                case 6:
                case "6":
                    stepDom = (<ProjAnswerChart pi={this.state.pid} ></ProjAnswerChart>);
                    // stepDom = (<QuestSkipCustApp pi={this.state.pid} onNextStep={this.onStep4} onBackToList={this.onBackToList} />);
                    break;
            }

            return (
                <>
                    <Row>
                        <Col xs="12">
                            <h2 className="mt-3 mb-3">
                                {"專案:" + (formData ? formData.name : "undefined")}
                                <Button className="ml-3 ezc-button-icon">

                                    <OverlayTrigger
                                        key={"step2"}
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-step2`}>下載問卷</Tooltip>
                                        }
                                    >
                                        <Download size={20} />
                                    </OverlayTrigger>
                                </Button>
                                <Button className="ml-3 ezc-button-icon" onClick={this.onClickTest}>進行手機測試</Button>
                            </h2>
                        </Col>
                    </Row>
                    <ProjectsCustStepper step={this.state.step - 1} pid={this.state.pid} isEditable={isEditable} history={this.props.history} />
                    {stepDom}
                </>
            );
        }
    }

    render() {
        const { handleOnUrlChange, renderContent } = this;
        return (
            <HashChange onChange={handleOnUrlChange} render={renderContent} />
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsEditCustApp))